<ng-template #currentTimeMarkerTemplate>
  <div class="cal-current-time-marker"></div>
</ng-template>
<nb-card class="nb_card_pop_up full_pop_up meal_item mobilePopup" style="width: 1200px; max-width: 95vw !important;">
  <nb-card-header class="d-flex align-items-center title">
    <div class="title">
      <span>{{ patient.firstName + ' ' + patient.lastName }}'s Program</span>
    </div>
    <button
      nbButton
      type="button"
      static="basic"
      ghost
      shape="round"
      size="small"
      class="ml-auto"
      [disabled]="isWaiting"
      (click)="onClose()"
    >
      <nb-icon icon="close"></nb-icon>
    </button>
  </nb-card-header>

  <nb-card-body>
    <ngx-patient-calendar [patient]="patient"></ngx-patient-calendar>
  </nb-card-body>

  <nb-card-footer *ngIf="planId > 0 || isFuture">
    <div class="actions">
      <button
        i18n="@@SendToClient"
        nbButton
        class="btn-circle btn-xl btn-main btn-circle btn-xl"
        
        [disabled]="isWaiting"
        [nbSpinner]="isWaiting"
        (click)="onSendToClient()"
      >
      <i class="fas fa-mobile-alt"></i>&nbsp;Send App Invite
      </button>
    </div>
  </nb-card-footer>
</nb-card>
